export default {
  // Update me with user
  updateStrings(state, data) {
    state.strings = data;
    state.stringsLoaded = true;
  },
  updateLanguage(state, data) {
    state.language = data;
  },
};
